<div class="loading-container" *ngIf="isLoading">
    <div class="spinner"></div>
    <p>Carregando dados...</p>
</div>

<div class="main-container" *ngIf="!isLoading && !toggle">
    <div class="close-background" (click)="onToggleClick($event)" (keyup)="onToggleClick($event)"></div>
    <div class="table-container" (click)="$event.stopPropagation()" (keyup)="$event.stopPropagation()">
        <div class="table-header">
            <button class="add-button" (click)="toggleForm()">+</button>
            <h2 class="title">TIME-TABLE</h2>
        </div>

        <div class="division"></div>
        <div class="scrollable-table">

            <table class="table">
                <thead>
                    <tr>
                        <th>VIAGEM</th>
                        <th>PROCESSO</th>
                        <th>CHEGADA SLA</th>
                        <th>SAÍDA SLA</th>
                        <th>EXTRA</th>
                        <th>AÇÕES</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let trip of data$ | async">
                        <td>{{trip.trip}}</td>
                        <td>{{trip.processDescription}}</td>
                        <td>{{trip.arrivalTimeSLA}}</td>
                        <td>{{trip.departureTimeSLA}}</td>
                        <td>{{trip.extra}}</td>
                        <td>
                            <div class="actions">

                                <ng-container *ngIf="mode === 'edit'">
                                    <button class="edit" (click)="openEditForm(trip)"><fa-icon
                                            [icon]="faPen"></fa-icon></button>
                                    <button class="delete" (click)="deleteTrip(trip.id!, trip.trip!)"><fa-icon
                                            [icon]="faTrash"></fa-icon></button>
                                </ng-container>
                                
                                <ng-container *ngIf="mode === 'selection'">
                                    <button class="edit" (click)="onSelectRow(trip, $event)"><fa-icon
                                            [icon]="faCheck"></fa-icon></button>
                                </ng-container>

                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<app-motores-transmissao-time-table-form *ngIf="showForm" class="overlay" (closeForm)="toggleForm()" (dataUpdated)="onDataUpdated()"
    [receivedTrip]="tripToEdit"> </app-motores-transmissao-time-table-form>